import { render, staticRenderFns } from "./SumPostsAndInteractionsInTime.vue?vue&type=template&id=45221a3e&"
import script from "./SumPostsAndInteractionsInTime.vue?vue&type=script&lang=js&"
export * from "./SumPostsAndInteractionsInTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports